// Old IDs are recognized only while existing data and browser state are migrated.
export const isLegacyWorker = value => ['3', '4', '5', '6'].includes(String(value));
export const hasWorker = job => Boolean(job?.cos_job_worker && !isLegacyWorker(job.cos_job_worker));
export const needsAcknowledgement = job => job?.status !== 'Cancelled'
    && (job?.requires_ack === true || job?.status === 'Updated');
export const importantRevision = job => job?.important_revision ?? (needsAcknowledgement(job) ? 1 : 0);
export function schedulingStatusKey(job) {
    return needsAcknowledgement(job) && ['New', 'Pending', 'Scheduled', 'Updated'].includes(job.status)
        ? 'Updated' : job.status;
}
export function matchesJobStatus(job, selected) {
    if (selected === 'ALL') return true;
    if (selected === 'Updated') return needsAcknowledgement(job);
    return schedulingStatusKey(job) === selected;
}
